import { render, staticRenderFns } from "./PerfumeCard.vue?vue&type=template&id=0f9cd65c&scoped=true&"
import script from "./PerfumeCard.vue?vue&type=script&lang=js&"
export * from "./PerfumeCard.vue?vue&type=script&lang=js&"
import style0 from "./PerfumeCard.vue?vue&type=style&index=0&id=0f9cd65c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9cd65c",
  null
  
)

export default component.exports